import { render, staticRenderFns } from "./MessageTextLines.vue?vue&type=template&id=4e1f18df"
import script from "./MessageTextLines.vue?vue&type=script&lang=js"
export * from "./MessageTextLines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports